<app-simple-modal-header
	[pageTitle]="pageTitle"
	(dismissed)="dismiss()"
></app-simple-modal-header>

<ion-content>
	<form [formGroup]="form" *ngIf="form">
		<ion-item>
			<ion-label position="stacked">
				Status:
			</ion-label>
			<ion-select
				placeholder="Select"
				class="text-wrap"
				[interfaceOptions]="{ header: 'Status' }"
				[formControl]="form.controls.status"
				[compareWith]="formHelper.compareWith"
			>
				<ion-select-option value="All">
					All
				</ion-select-option>
				<ion-select-option
					*ngFor="let option of statusOptions"
					[value]="option"
				>
					{{ option.status }}
				</ion-select-option>
			</ion-select>
		</ion-item>
		<ion-item>
			<ion-label position="stacked">
				Category:
			</ion-label>
			<ion-select
				placeholder="Select"
				class="text-wrap"
				[interfaceOptions]="{ header: 'Category' }"
				[formControl]="form.controls.category"
				(ionChange)="onChangeCategory($event.detail.value)"
				[compareWith]="formHelper.compareWith"
				[value]="defaultCategoryOption"
			>
				<ion-select-option [value]="defaultCategoryOption">
					{{ defaultEquipmentOption.name }}
				</ion-select-option>
				<ion-select-option
					*ngFor="let category of categoryOptions"
					[value]="category"
				>
					{{ category.name }}
				</ion-select-option>
			</ion-select>
		</ion-item>
		<ion-item>
			<ion-label position="stacked">
				Equipment:
			</ion-label>
			<ion-select
				placeholder="Select"
				class="text-wrap"
				[interfaceOptions]="{ header: 'Equipment' }"
				[formControl]="form.controls.equipment"
				[compareWith]="formHelper.compareWith"
			>
				<ion-select-option [value]="defaultEquipmentOption">
					{{ defaultEquipmentOption.name }}
				</ion-select-option>
				<ion-select-option
					*ngFor="let equip of equipmentOptions"
					[value]="equip"
				>
					{{ equip.name }}
				</ion-select-option>
			</ion-select>
		</ion-item>
	</form>
</ion-content>

<ion-footer>
	<ion-button
		(click)="onClickApplyFilter()"
		expand="block"
		class="modal__submit"
	>
		Apply Filter
	</ion-button>
</ion-footer>
